const getMixpanelApiHost = (region = "us") => {
	switch (region) {
		case "":
		case "us":
			return "https://api.mixpanel.com";
		case "eu":
			return "https://api-eu.mixpanel.com";
		default:
			throw new Error('NEXT_PUBLIC_MIXPANEL_REGION must be "us" or "eu".');
	}
};

module.exports = getMixpanelApiHost;
